
import { Box, Container, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import ContentLinks from "../../components/contentLinks/ContentLinks";

import icon1 from '../../assets/imgs/MinistryOfRuralDevelopment.png';
import pmgsy from '../../assets/imgs/logos/pmgsy-logo.png'
import MGNREGA from '../../assets/imgs/logos/MGNREGA_Logo.png'
import DAY from '../../assets/imgs/logos/DAY-NRLM.png'
import DDU from '../../assets/imgs/logos/DDU-GKY.png'
import NSAP from '../../assets/imgs/logos/NSAP.png'
import PMAY from '../../assets/imgs/logos/PMAY-G.png'

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import '../layouts/style.css'
import useWindowSize from "../../components/windowSize/useWindowSize";

export default function RelatedWebsites() {
  const { fontSize } = useTheme();
  const windowSize=useWindowSize();
  return (
    <Box sx={{ maxWidth: '100vw', marginTop:"2rem", textAlign:"center", background:"#f0ede5", padding:"5px 0"}}>
      <Typography variant="h5" style={{fontSize:`${fontSize+0.3}rem`, fontWeight:"bold",margin:"5px 0"}}>Related Websites</Typography>
      <Container style={{ width: "100%" }}>

        <Swiper
          centeredSlides={false}
          centerInsufficientSlides={true}
          slidesPerView={windowSize>1000?4:windowSize>600?2:1}
          loop={true}
          pagination={{
            clickable: true,
          }}
          navigation={true}
          modules={[Pagination, Navigation, Autoplay]}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            stopOnLastSlide: false
          }}
          className="mySwiper"
        >
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks link={'https://awaassoft.nic.in/netiay/newreport.aspx'} name={''} icon={PMAY} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks link={'https://rural.gov.in/'} name={'Ministry of Rural Development'} icon={icon1} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks link={'https://pmgsy.nic.in/'} name={'Pradhan Mantri Gram Sadak Yojana (PMGSY)s'} icon={pmgsy} />

            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks link={'https://nrega.nic.in/'} name={'NREGA'} icon={MGNREGA} />

            </div>
          </SwiperSlide>
          
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks link={'https://panchayat.gov.in/'} 
              name={'Ministry of Panchayati Raj'} 
              icon={icon1} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks
                link={'https://skilldevelopment.gov.in/#'}
                name={'Ministry of Skill Development and Entrepreneurship'}
                icon={icon1}
              />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks
                link={'https://dolr.gov.in/'}
                name={'Department of Land Resource'}
                icon={icon1}
              />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks
                link={'http://ddugky.info/'}
                name={''}
                icon={DDU}
              />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks
                link={'https://nsap.nic.in/'}
                name={'National Social Assistance Programme (NSAP)'}
                icon={NSAP}
              />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks
                link={'https://aajeevika.gov.in/'}
                name={'DAY-NRLM'}
                icon={DAY}
              />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks link={'https://rurban.gov.in/'} name={'National Urban Mission'} icon={icon1} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div style={{ width: "100%", display: "flex", justifyContent:"center", alignItems:"center" }}>
              <ContentLinks link={'https://dolr.gov.in/'} name={'Ministry of Panchayati Raj'} icon={icon1} />
            </div>
          </SwiperSlide>
        </Swiper>
      </Container>
    </Box>
  );
}
